// Constants
export const datos_asesor = () => {
    return {
        datos_asesor: {
            id: {
                namepath: ['admin_asesores'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            id_list_estado: {
                type: "text",
                label: "Estado",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_estado",
                    label: 'name'
                }
            },
            documento: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: '',
                    prepend: '',
                    append: '',
                }
            },
            name: {
                type: "text",
                label: "Nombre",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            email: {
                type: "text",
                label: "Correo",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "email",
                    disabled: false,
                    predeterminate: "",
                }
            },
            telefonos: {
                type: "text",
                label: "Telefonos",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            ccf: {
                type: "number",
                label: "Afiliación Ccf",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            afp: {
                type: "number",
                label: "Afiliación Afp",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            r1: {
                type: "number",
                label: "Afl r1",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            r2: {
                type: "number",
                label: "Afl r2",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            r3: {
                type: "number",
                label: "Afl r3",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            r4: {
                type: "number",
                label: "Afl r4",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            r5: {
                type: "number",
                label: "Afl r5",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            comision: {
                type: "number",
                label: "Comisión mensual",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            admin: {
                type: "number",
                label: "Administración",
                placeholder: "",
                namepath: ['admin_asesores'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}